module.exports = __webpack_public_path__ + "static/media/fb.ef201783.svg";